import { type App } from "vue"
import { createI18n } from "vue-i18n"

export const i18n = createI18n({
    legacy: false,
    locale: "fr",
    datetimeFormats: {
        fr: {
            short: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
    },
})

export default {
    install(app: App) {
        app.use(i18n)
    },
}
